import { Alert, Button, Form, Input, InputNumber, Upload } from 'antd'
import type { UploadFile, UploadProps } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react'
import style from './Topup.module.css'
import { Account, Client, Topup } from 'types'
import axiosClient from 'axios-client'
import { InboxOutlined } from '@ant-design/icons'
import balanceImg from 'assets/img/Balance.png'
import cihImg from 'assets/img/CIH.png'
import payoneerImg from 'assets/img/Payoneer.png'
import cryptoImg from 'assets/img/Cryptocurrency.png'
import { toast } from 'react-toastify'

interface TopupFormProps {
  topupLink: Account | Client
  closePopup?: () => void
}

const TopupForm: React.FC<TopupFormProps> = (props: TopupFormProps) => {
  const [form] = Form.useForm()

  const { topupLink } = props

  const [topup, setTopup] = useState<Topup>({ amount:100, type:'crypto'} as Topup)
  const [calculatedFees, setCalculatedFees] = useState(0)
  

  const [fileList, setFileList] = useState<UploadFile[]>([])

  useEffect(() => {
    handleAmount()
  }, [topup.amount,topup.type])

  /** Upload file */
  const { Dragger } = Upload
  const draggerRef = React.useRef<HTMLInputElement>(null);

  const uploadProp: UploadProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,
    listType: 'text',
    accept : ".jpg,.jpeg,.png,.pdf",
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        console.log(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        console.log(`${info.file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
    beforeUpload(file: UploadFile, fileLists: UploadFile[]) {
      const isImage = file.type?.startsWith('image/');
      const isPDF = file.type === 'application/pdf';

      if (!isImage && !isPDF) {
        toast.error('You can only upload image or PDF files!');
        return Upload.LIST_IGNORE; // Prevent upload
    }

      setFileList(fileLists) // Update state with selected files
      return false // Prevent automatic upload (if desired)
    },
  }

  const handleAmount = () => {
    if (!topup.amount) return

    let totalFees = 0

    if (topupLink.type === 'client') {
      totalFees = totalFees + (topup.amount * topupLink.bank_fee) / 100
    } else {
      totalFees = totalFees + (topup.amount * topupLink.commission) / 100

      if (topup.type !== 'balance' && topupLink.client?.bank_fee) {
        totalFees = totalFees + (topup.amount * topupLink.client.bank_fee) / 100
      }
    }

    setCalculatedFees(totalFees)
  }

  /* Submit */
  const onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    const payload = {
      amount: topup.amount,
      reference: topup.reference,
      type: topup.type,
      proof: fileList[0],
      client_id:
        topupLink.type === 'account' && topupLink.client ? topupLink.client?.id : topupLink.id,
      account_id: topupLink.type === 'account' ? topupLink.id : null,
    }

    // Send the data to your server (e.g., using fetch)
    axiosClient
      .post('/topups', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        props.closePopup && props.closePopup()
      })
  }

  /** Copy Rib, Email and wallet **/
  const [copied, setCopied] = useState(false)
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }

  return (
    <Form
      form={form}
      layout="vertical"
    >
      <div className={style.form_container}>
        <div>
          <Form.Item
            
            label="Amount"
            name="amount"
            rules={[{ required: true, message: 'Please input the amount you wish to top up!' }]}
          >
            <InputNumber
            className={style.input}
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
              step={100}
              onChange={val => {
                setTopup({ ...topup, amount: val || 0 })
              }}
              defaultValue={100}
            />
          </Form.Item>

          <Form.Item
            label="Transfert reference"
            name="reference"
            rules={[{ required: true, message: 'Please input the transfert reference!' }]}
          >
            <Input
            className={style.input}
              onChange={e => setTopup({ ...topup, reference: e.target.value || '' })}
              value={topup.amount}
            />
          </Form.Item>
          <p>Total amount : {topup.amount + calculatedFees}$ </p>
        </div>

        <div className={style.upload_container}>
          <Dragger
            {...uploadProp}
            className={style.upload_div}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Drag & drop files or Browse</p>
            <p className="ant-upload-hint">
              Supported formates: JPEG, PNG, PDF <br />
              Maximum file size: 5 MB or less.
            </p>
            <input
              type="file"
              ref={draggerRef}
              style={{ display: 'none' }}
            />
          </Dragger>
          <Button
            icon={<UploadOutlined />}
            className={style.upload_button}
            onClick={() => draggerRef.current?.click()}
          >
            Upload
          </Button>
        </div>
      </div>

      <div className={style.radio_container}>
        
      <div className={style.radio}>
          <input
            type="radio"
            id="crypto"
            name="payment_option"
            value="crypto"
            onChange={()=> setTopup({...topup, type: 'crypto'}) }
            checked={topup.type==='crypto'}
          />
          <label htmlFor="crypto">
            <img
              src={cryptoImg}
              alt="Crypto"
            />
          </label>
        </div>

        <div className={style.radio}>
          <input
            type="radio"
            id="cih_bank"
            name="payment_option"
            value="cih_bank"
            onChange={()=>setTopup({...topup, type: 'bank'}) }
            checked={topup.type==='bank'}
          />
          <label htmlFor="cih_bank">
            <img
              src={cihImg}
              alt="CIH Bank"
            />
          </label>
        </div>
        <div className={style.radio}>
          <input
            type="radio"
            id="payoneer"
            name="payment_option"
            value="payoneer"
            onChange={()=>setTopup({...topup, type: 'payoneer'}) }
            checked={topup.type==='payoneer'}
          />
          <label htmlFor="payoneer">
            <img
              src={payoneerImg}
              alt="Payoneer"
            />
          </label>
        </div>
        

        { topupLink.type === 'account' &&

      <div className={style.radio}>
          <input
            type="radio"
            id="balance"
            name="payment_option"
            value="balance"
            onChange={()=>setTopup({...topup, type: 'balance'}) }
            checked={topup.type==='balance'}
          />
          <label htmlFor="balance">
            <img
              src={balanceImg}
              alt="Balance"
            />
          </label>
        </div>
        }
      </div>

      <div className={style.info_container}>

        { topup.type === 'bank' && 
        <>
        <span>RIB</span>
        <div
          className={style.clipboard}
          onClick={() => handleCopy('230021265225321101850036')}
        >
          230 021 2652253211018500 36
        </div>
        </>
        }

{ topup.type === 'payoneer' && 
        <>
        <span>Email Address</span>
        <div
          className={style.clipboard}
          onClick={() => handleCopy('Kogafayer@gmail.com')}
        >
          Kogafayer@gmail.com
        </div>
        </>

        }

{ topup.type === 'crypto' && 
        <>
        <span>Wallet Address</span>
        <div
          className={style.clipboard}
          onClick={() => handleCopy('TMye4A2tHq6ZfSQKKygad9zsyBfwsPDBSj')}
        >
          TMye4A2tHq6ZfSQKKygad9zsyBfwsPDBSj
        </div>
        </>

        }
        
        { copied &&
          <Alert message="Copied to clipboard!" type="success" showIcon />
        }
        
      </div>

      <div className={style.footer}>
        <Button
          className={style.cancel_button}
          onClick={props.closePopup}
        >
          Cancel
        </Button>
        <Button
          htmlType="submit"
          className={style.submit_button}
          onClick={onSubmit}
        >
          Save
        </Button>
      </div>
    </Form>
  )
}

export default TopupForm
